import React from 'react';

function Whitepaper(): React.ReactElement {
  window.location.replace('https://doublesumgang.com/assets/LITEPAPER.pdf');
  return <div></div>;
}

export default Whitepaper;
